import r from"@babel/runtime/helpers/toConsumableArray";var e=function e(a){return a.reduce((function(a,u){return[].concat(r(a),r(Array.isArray(u.value)?e(u.value):[u.value]))}),[])};export{e as default};
